import { If } from "components";
import { AttributeValue } from "modules/categories";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Button } from "ui";

import { getProductsFiltersAmount } from "../../helpers";
import {
  AdditionalAttributeFilter,
  CategoriesFilter,
  ColorsFilter,
  PriceFilter,
  StatusFilter,
  SizeFilter
} from "./atoms";
import { ProductsFilterProps } from "./ProductsFilter.types";

import styles from "./ProductsFilter.module.scss";

const ProductsFilter = ({
  categories,
  filterMeta,
  isCategoriesLoading
}: ProductsFilterProps) => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();

  const [filtersCounter, setFiltersCounter] = useState(0);

  const navigate = useNavigate();

  const additionalAttributes =
    filterMeta?.attributes.filter(
      (attribute) => attribute.type === "Additional"
    ) ?? [];

  const colorAttributeValues = filterMeta?.attributes.find(
    (attribute) => attribute.name === "Color"
  )?.values;

  const sizeAttributeValues = filterMeta?.attributes.find(
    (attribute) => attribute.name === "Size"
  )?.values;

  useEffect(() => {
    setFiltersCounter(
      getProductsFiltersAmount({
        searchParams,
        filterMinPrice: filterMeta?.minPrice,
        filterMaxPrice: filterMeta?.maxPrice
      })
    );
  }, [searchParams, filterMeta]);

  const clearButtonLabel = filtersCounter
    ? `${t("Clear All")} (${filtersCounter})`
    : t("Clear All");

  return (
    <div className={styles.filterContainer}>
      <div className={styles.filter}>
        <Button
          className={styles.filter_clearBtn}
          variant="default"
          title={clearButtonLabel}
          onClick={() => navigate({ search: "" })}
        />

        <div className={styles.filter_separatorLine} />

        <StatusFilter />

        <div className={styles.filter_separatorLine} />

        <CategoriesFilter
          categories={categories}
          isCategoriesLoading={isCategoriesLoading}
        />

        <div className={styles.filter_separatorLine} />

        <If condition={sizeAttributeValues}>
          <>
            <SizeFilter
              sizeAttributeValues={sizeAttributeValues as AttributeValue[]}
            />

            <div className={styles.filter_separatorLine} />
          </>
        </If>

        {additionalAttributes.map((attribute) => (
          <AdditionalAttributeFilter
            key={attribute.id}
            additionalAttribute={attribute}
          />
        ))}

        <ColorsFilter colorAttributeValues={colorAttributeValues} />

        <div className={styles.filter_separatorLine} />

        <If
          condition={
            filterMeta &&
            filterMeta.maxPrice !== 0 &&
            filterMeta.maxPrice !== filterMeta.minPrice
          }
        >
          <PriceFilter
            minPrice={filterMeta?.minPrice as number}
            maxPrice={filterMeta?.maxPrice as number}
          />
        </If>
      </div>
    </div>
  );
};

export default ProductsFilter;
